export enum Gender {
  Male = 'male',
  Female = 'female',
  Diverse = 'diverse'
}

export interface Technician {
  id: string
  firstName: string
  lastName: string
  gender: Gender | null
  slogan: string
  picture: string
  feedbackSlug: string
  profilePicFaceBox: {
    parentDimensions: {
      height: number
      width: number
    }
    x: number
    y: number
    height: number
    width: number
  }
}
